import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Select } from "antd";

import { DishType } from "../../../../constants/enums";
import css from "./DishRightBlockInfoModal.module.css";
import { menuCategoriesActions } from "../../../../store/slices/settings-slices";
import { DishRightBlockSingleNumberReusModal } from "../DishRightBlockSingleNumberReusModal/DishRightBlockSingleNumberReusModal";
import { getConfig } from "../../../../config";

const DishRightBlockInfoModal = ({
  selectedCategory,
  setSelectedCategory,
  handleCategoryChange,
}) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const { cityCode } = getConfig();
  const { menuCategories, trigger } = useSelector(
    (store) => store.menuCategories
  );

  const {
    register,
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    dispatch(menuCategoriesActions.getAllMenuCategories());
  }, [trigger, dispatch]);

  return (
    <div className={css.wrap}>
      <div className={css.inputGroup}>
        <label htmlFor="group">Group</label>
        <Select
          id="group"
          mode="multiple"
          value={selectedCategory}
          onChange={handleCategoryChange}
          placeholder="Select categories"
          style={{ width: '70%' }}
          showSearch
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
          options={menuCategories?.map((obj) => ({
            value: obj.id,
            label: obj.name[currentLanguage] || obj.name["en"]
          })) || []}
        />
      </div>

      {errors.nameEn && <p className={css.error}>{errors.nameEn.message}</p>}
      <div className={css.inputGroup}>
        <label htmlFor="nameEn">
          {t("modal-name-input-new-category")} (English)
        </label>
        <input
          type="text"
          id="nameEn"
          {...register("nameEn", { required: "This field is required" })}
        />
      </div>

      {errors.nameRu && <p className={css.error}>{errors.nameRu.message}</p>}
      <div className={css.inputGroup}>
        <label htmlFor="nameRu">
          {t("modal-name-input-new-category")} (Русский)
        </label>
        <input
          type="text"
          id="nameRu"
          {...register("nameRu", { required: "This field is required" })}
        />
      </div>

      {cityCode === "UAE" ? (
        <>
          {errors.nameAr && (
            <p className={css.error}>{errors.nameAr.message}</p>
          )}
          <div className={css.inputGroup}>
            <label htmlFor="nameAr">
              {t("modal-name-input-new-category")} (العربية)
            </label>
            <input
              type="text"
              id="nameAr"
              {...register("nameAr", { required: "This field is required" })}
            />
          </div>
        </>
      ) : (
        <>
          {errors.nameKa && (
            <p className={css.error}>{errors.nameKa.message}</p>
          )}
          <div className={css.inputGroup}>
            <label htmlFor="nameKa">
              {t("modal-name-input-new-category")} (ქართული)
            </label>
            <input
              type="text"
              id="nameKa"
              {...register("nameKa", { required: "This field is required" })}
            />
          </div>
        </>
      )}

      <div className={css.inputGroup}>
        <label htmlFor="descriptionEn">
          {t("modal-Description-input")} (English)
        </label>
        <input type="text" id="descriptionEn" {...register("descriptionEn")} />
      </div>

      <div className={css.inputGroup}>
        <label htmlFor="descriptionRu">
          {t("modal-Description-input")} (Русский)
        </label>
        <input type="text" id="descriptionRu" {...register("descriptionRu")} />
      </div>

      {cityCode === "UAE" ? (
        <>
          {errors.descriptionAr && (
            <p className={css.error}>{errors.descriptionAr.message}</p>
          )}
          <div className={css.inputGroup}>
            <label htmlFor="descriptionAr">
              {t("modal-Description-input")} (العربية)
            </label>
            <input
              type="text"
              id="descriptionAr"
              {...register("descriptionAr")}
            />
          </div>
        </>
      ) : (
        <>
          {errors.descriptionKa && (
            <p className={css.error}>{errors.descriptionKa.message}</p>
          )}
          <div className={css.inputGroup}>
            <label htmlFor="descriptionKa">
              {t("modal-Description-input")} (ქართული)
            </label>
            <input
              type="text"
              id="descriptionKa"
              {...register("descriptionKa")}
            />
          </div>
        </>
      )}

      <fieldset
        style={{
          border: "1px solid #d9d9d9",
          borderRadius: 8,
          padding: "10px 14px",
          margin: "16px 0",
        }}
      >
        <legend
          style={{
            fontSize: 12,
            color: "#8c8c8c",
            fontWeight: 600,
            padding: "0 6px",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
        >
          {t("Dish Type")}
        </legend>
        <div style={{ display: "flex-column", gap: 24 }}>
          <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
            <input
              type="radio"
              value={DishType.REGULAR}
              {...register("type")}
              style={{ accentColor: "#1677ff", width: 15, height: 15 }}
            />
            {t("Regular")}
          </label>
          <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
            <input
              type="radio"
              value={DishType.BASE}
              {...register("type")}
              style={{ accentColor: "#1677ff", width: 15, height: 15 }}
            />
            {t("Base")}
          </label>
          <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
            <input
              type="radio"
              value={DishType.PROTEIN}
              {...register("type")}
              style={{ accentColor: "#1677ff", width: 15, height: 15 }}
            />
            {t("Protein")}
          </label>
          <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
            <input
              type="radio"
              value={DishType.SAUCE}
              {...register("type")}
              style={{ accentColor: "#1677ff", width: 15, height: 15 }}
            />
            {t("Sauce")}
          </label>
        </div>
      </fieldset>

      <div className={css.numbersBlock}>
        <DishRightBlockSingleNumberReusModal
          positionName={t("modal-energy")}
          overrideLabel={t("override")}
        />

        <DishRightBlockSingleNumberReusModal
          positionName={t("modal-proteins")}
          overrideLabel={t("override")}
        />

        <DishRightBlockSingleNumberReusModal
          positionName={t("modal-fats")}
          overrideLabel={t("override")}
        />

        <DishRightBlockSingleNumberReusModal
          positionName={t("modal-carbohydrates")}
          overrideLabel={t("override")}
        />

        <DishRightBlockSingleNumberReusModal
          positionName={t("Cost")}
          overrideLabel={t("override")}
        />
      </div>
    </div>
  );
};

export { DishRightBlockInfoModal };
